// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__A8ik9","icon":"holding-image_icon__0g0Wy"};